import { render, staticRenderFns } from "./tableBtn.vue?vue&type=template&id=39ef2a23&scoped=true&"
import script from "./tableBtn.vue?vue&type=script&lang=js&"
export * from "./tableBtn.vue?vue&type=script&lang=js&"
import style0 from "./tableBtn.vue?vue&type=style&index=0&id=39ef2a23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ef2a23",
  null
  
)

export default component.exports